if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    // --- FIX: recalculer la variante réelle (en lisant UNIQUEMENT les champs liés au form) ---
try {
  // 1) Récupère le form réel
  const form =
    this.form ||
    this.querySelector('form') ||
    this.closest('form');

  if (!form) throw new Error('No form found for product-form');

  const formId = form.getAttribute('id'); // souvent "product-form-xxxx"
  const scope = document; // IMPORTANT: on cherche dans tout le document, mais filtré par form=...

  // 2) Récupère les JSON (depuis la section id)
  const sectionId = this.dataset.section || null;

  const variantsEl =
    (sectionId && document.getElementById(`VariantsJSON-${sectionId}`)) ||
    document.querySelector('script[id^="VariantsJSON-"]');

  const optionsEl =
    (sectionId && document.getElementById(`OptionsJSON-${sectionId}`)) ||
    document.querySelector('script[id^="OptionsJSON-"]');

  if (!variantsEl || !optionsEl) throw new Error('Missing VariantsJSON/OptionsJSON');

  const variants = JSON.parse(variantsEl.textContent || '[]');
  const optionNames = JSON.parse(optionsEl.textContent || '[]'); // ex: ["Couleur","Taille"]

  // 3) Utilitaires pour ne lire que les controls liés à CE form
  const qAll = (sel) => {
    const inside = Array.from(form.querySelectorAll(sel));
    const linked = formId ? Array.from(scope.querySelectorAll(`${sel}[form="${CSS.escape(formId)}"]`)) : [];
    // dédoublonne
    return Array.from(new Set([...inside, ...linked]));
  };

  const getSelectedFor = (optionName, idx) => {
    const escaped = CSS.escape(optionName);

    // radios name="options[Couleur]"
    const radios = qAll(`input[type="radio"][name="options[${escaped}]"]`);
    const checkedRadio = radios.find(r => r.checked);
    if (checkedRadio?.value) return String(checkedRadio.value);

    // select name="options[Couleur]"
    const selects = qAll(`select[name="options[${escaped}]"]`);
    if (selects[0]?.value) return String(selects[0].value);

    // fallbacks option-1 / option-2
    const radios2 = qAll(`input[type="radio"][name="option-${idx + 1}"]`);
    const checked2 = radios2.find(r => r.checked);
    if (checked2?.value) return String(checked2.value);

    const selects2 = qAll(`select[name="option-${idx + 1}"]`);
    if (selects2[0]?.value) return String(selects2[0].value);

    return null;
  };

  const variantOptionAt = (v, idx) => {
    if (Array.isArray(v?.options) && v.options[idx] != null) return v.options[idx];
    const k = `option${idx + 1}`; // option1/2/3
    if (v && v[k] != null) return v[k];
    return null;
  };

  // 4) Valeurs sélectionnées (couleur / taille / etc.)
  const selected = optionNames.map((name, idx) => getSelectedFor(name, idx));

  // Auto-fill si option unique possible
  const filled = [...selected];
  filled.forEach((val, idx) => {
    if (val !== null) return;
    const values = [...new Set(variants.map(v => variantOptionAt(v, idx)).filter(Boolean))];
    if (values.length === 1) filled[idx] = String(values[0]);
  });

  // 5) Match variante
  const match = variants.find(v =>
    v?.id &&
    filled.every((val, idx) => val !== null && String(variantOptionAt(v, idx)) === String(val))
  );

  if (!match?.id) {
    this.submitButton.classList.remove('loading');
    this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    this.submitButton.removeAttribute('aria-disabled');
    this.handleErrorMessage('Veuillez sélectionner les options (couleur / taille).');
    return;
  }

  // 6) Forcer l'ID de variante
  const idInput =
    form.querySelector('[name="id"]') ||
    this.querySelector('[name="id"]');

  if (idInput) idInput.value = String(match.id);

} catch (e) {
  console.warn('Variant recompute failed', e);
}
// --- END FIX ---
      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // CART ERROR EVENT
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.section,
              },
            })
          );
          // -------------------------------------------

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});

            // CART CHANGE EVENT
            document.dispatchEvent(
              new CustomEvent("cart:change", {
                detail: response,
                bubbles: true,
              })
            );
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
